import { dataReportSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconReportSolid = /*#__PURE__*/createIcon(dataReportSolid)
export default IconReportSolid
